var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderComponent'),(_vm.getUser)?_c('History'):_vm._e(),_c('FooterComponent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }